export default __webpack_public_path__ + "static/download-qr-6911ebc69573edd94c8bad15ef0ddb7d.png";